import React from 'react';
import CardField from './CardField';
import Textarea from 'react-textarea-autosize';
import styles from './CardField.scss';

export default class CardTextArea extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      fieldValue: ''
    };
    this.onBlur = this.onBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  onBlur() {
    this.setState({
      fieldValue: this.state.fieldValue.trim()
    });
  }

  handleChange(event) {
    this.setState({ fieldValue: event.target.value });
  }

  render() {
    return (
      <CardField {...this.props}>
        <Textarea
          className={`transparent fluid ${styles.textArea}`}
          rows={1}
          onBlur={this.onBlur}
          value={this.state.fieldValue}
          onChange={this.handleChange}
          {...this.props}
        />
      </CardField>
    );
  }

}



// WEBPACK FOOTER //
// ./webpack/components/Elements/CardField/CardTextArea.js